import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import SearchResults from './SearchResults'; // Import the SearchResults component
import WithIframeAccess from './WithIframeAccess'; 
import Score from './Evaluate';
import ScoringResults from './ScoringResult';
import UploadFramework from './Upload';

function App() {
  const [keywords, setKeywords] = useState(['']);
  const [courses, setCourses] = useState([]);
  const [currentCourse, setCurrentCourse] = useState('');
  const [searchMode, setSearchMode] = useState('ALL');
  const navigate = useNavigate(); // Hook to navigate programmatically

  const addKeyword = () => setKeywords([...keywords, '']);
  const removeKeyword = (index) => {
    setKeywords(keywords.filter((_, i) => i !== index));
  };

  const addCourse = () => {
    if (currentCourse.trim() && !courses.includes(currentCourse)) {
      setCourses([...courses, currentCourse]);
      setCurrentCourse(''); // Clear the input after adding
    }
  };


  const removeCourse = (index) => {
    setCourses(courses.filter((_, i) => i !== index));
  };

  const handleSearch = () => {
    // Trim the keywords and filter out any empty values
    const validKeywords = keywords.map(keyword => keyword.trim()).filter(keyword => keyword !== '');
  
    // Add the current course to the courses list if it is not empty
    let updatedCourses = [...courses];
    if (currentCourse.trim() && !updatedCourses.includes(currentCourse.trim())) {
      updatedCourses.push(currentCourse.trim());
    }
  
    // Check that there is at least one valid keyword and one course
    if (updatedCourses.length === 0) {
      alert('Please enter at least one course.');
      return;
    }
  
    if (validKeywords.length === 0) {
      alert('Please enter at least one valid keyword.');
      return;
    }

    let searchParams = {
      keywords: validKeywords,
      courses: updatedCourses,
      searchMode
    };

    if (keywords.length === 1) {
      searchParams = {
        keywords: validKeywords,
        courses: updatedCourses,
        searchMode: "ALL"
      }
    }
  
    
  
    navigate('/search-results', { state: searchParams }); // Pass search params to SearchResults
  };

  const placeholderText =
    searchMode === 'ALL'
    ? 'Enter search keyword (The result must contain ALL keywords)'
    : 'Enter search keyword (The result must contain ANY of the keywords)';

  return (
    <div className="main-body">
      <div className="top-bar">
        <img className='logo' src="logo.svg" alt="logo" />
      </div>
      <div className="content">
        <div className="title">What would you like to search for?</div>
        
        {/* Course Search Input */}
        <div className="course-search-container" style={{ marginBottom: '20px' }}>
          <div className="course-input-box" style={{ display: 'flex', alignItems: 'center', marginRight: "92px", marginLeft: "92px", marginTop: "20px" }}>
            <input
              type="text"
              placeholder="Enter course (e.g., PHYS211)"
              value={currentCourse}
              onChange={(e) => setCurrentCourse(e.target.value.toUpperCase())}
              style={{ flex: '1', fontSize: '18px', marginRight: '10px', padding: '20px', borderRadius: "10px", border: '1px solid #ccc' }}
            />
            <button onClick={addCourse} style={{ padding: '21.3px', fontSize: '16px', cursor: 'pointer', background: '#fff', border: '1px solid #ccc', color: '#000', borderRadius: "10px" }}>
              +&nbsp; Add Course
            </button>
          </div>
          {/* Display Added Courses */}
          <div className="course-tags" style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', marginLeft: "92px", marginRight: "92px" }}>
            {courses.map((course, index) => (
              <div key={index} style={{ background: '#eee', padding: '12px', borderRadius: '20px', margin: '5px', display: 'flex', alignItems: 'center' }}>
                {course}
                <button
                  onClick={() => removeCourse(index)}
                  style={{ marginLeft: '8px', background: 'none', border: 'none', cursor: 'pointer' }}
                >
                  &times;
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Keyword Search Input */}
        <div className="search-container">
          <div className="input-box">
            {keywords.map((keyword, index) => (
              <div className="input-row" key={index} style={{ display: 'flex', alignItems: 'center' }}>
                <img src="search-logo.svg" alt="search icon"></img>
                <input
                  type="text"
                  placeholder={placeholderText}
                  value={keyword}
                  onChange={(e) => {
                    const newKeywords = [...keywords];
                    newKeywords[index] = e.target.value;
                    setKeywords(newKeywords);
                  }}
                  style={{ flex: '1', fontSize: '18px', marginLeft: '10px', padding: "20px" }}
                />
                {index === keywords.length - 1 ? (
                  <button onClick={addKeyword} style={{ padding: '8px 16px', fontSize: '16px', cursor: 'pointer', background: '#fff', border: "none", color: '#000', marginLeft: '10px' }}>+&nbsp; Add Keyword</button>
                  
                ) : (
                  <button className='remove-button' onClick={() => removeKeyword(index)} style={{ padding: '5px', cursor: 'pointer', background: 'none', border: 'none', marginLeft: '10px' }}>
                    <img className="remove-img" src="remove.svg" alt="remove icon"></img>
                  </button>
                )}
              </div>
            ))}
          </div>

          {/* Search Mode */}
          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <label>
              <input type="radio" value="ALL" checked={searchMode === 'ALL'} onChange={() => setSearchMode('ALL')} style={{ marginRight: '5px' }} />
              Contain all keywords (ALL)
            </label>
            <label style={{ marginLeft: '20px' }}>
              <input type="radio" value="OR" checked={searchMode === 'OR'} onChange={() => setSearchMode('OR')} style={{ marginRight: '5px' }} />
              Contain any keywords (ANY)
            </label>
          </div>

          {/* Search Button */}
          <button onClick={handleSearch} style={{ width: '30%', padding: '15px', fontSize: '16px', backgroundColor: '#000', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', margin: '20px auto 20px auto', display: "flex", justifyContent: "center", alignItems: "center" }}>
            Search
          </button>

          <div className='button-white'></div>
        </div>
      </div>
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      {/* <WithIframeAccess> */}
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/search-results" element={<SearchResults />} />
          <Route path="/score" element={<Score />} />
          <Route path="/score-results" element={<ScoringResults />} /> 
          <Route path="/upload-framework" element={<UploadFramework />} />
        </Routes>
      {/* </WithIframeAccess> */}
    </Router>
  );
}
export default AppWrapper;
